import { useMutation } from 'react-query';

import { berryApiService } from 'src/services/berry.service';
import { IBerryChatResponse, IBerryMessagePayload } from 'src/models/berry.model';

export default function useBerryChat() {
  return useMutation<IBerryChatResponse, Error, IBerryMessagePayload>(
    (payload) => berryApiService.sendMessage(payload),
  );
}
